import React from "react";

import {
  AsteriskTooltip,
  AsteriskTooltipProps,
} from "components/common/AsteriskTooltip/AsteriskTooltip";
import { IntegrationType } from "graphql/types";

export const MANUAL_INTEGRATION_TYPES = [IntegrationType.DirectIngest, IntegrationType.Human];

export const ManualTransactionTooltip = ({
  integrationType,
  ...props
}: AsteriskTooltipProps & {
  integrationType: IntegrationType;
}) => {
  const isVisible = MANUAL_INTEGRATION_TYPES.includes(integrationType);

  return isVisible ? (
    <AsteriskTooltip content="This transaction was created manually." {...props} />
  ) : null;
};

export const AvailableDateTooltip = (props: AsteriskTooltipProps) => {
  return <AsteriskTooltip content="Available date" {...props} />;
};
